/*
THIS IS THE COMPONENT THAT WILL BE USED TO RENDER THE FOLLOWING CONTENT
- FIRST AND LAST NAME
- PHONE NUMBER
- COMPANY
- DELIVERY INSTRUCTIONS, ADDRESS, APT
- CITY, PROVINCE, COUNTRY AND ZIP
- OPTION TO SAVE THE INFORMATION
*/

import React, { useState, useEffect, useRef } from 'react';
import './ShippingAddress.css';
import { makeStyles } from '@material-ui/core/styles';
import CustomTextField from './CustomTextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Paper from '@material-ui/core/Paper';
import { setCustomerInfo, updateShippingAddress, updateCustomer, setCanContinue, setShippingAddress, setExpandedType } from '../../../actions/actionCreators';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import AutoCompleteField from './AutoCompleteField';
import CartService from '../../../services/CartService';
import { useTranslation } from 'react-i18next';

const width10 = { width: '10%' };
const width30 = { width: '30%' };
const width40 = { width: '40%' };
const width45 = { width: '45%' };
const width60 = { width: '60%' };
const width100 = { width: '100%' };
const marginTop10 = { marginLeft: '-10px' };

// MuiFormControlLabel-label

const useStyles = makeStyles(theme => ({
  root: {
    "& .MuiFormControlLabel-label": {
      fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
      fontWeight: 600,
    },
    "& .MuiTypography-body1": {
      fontSize: "1rem",
    },
  },

  [theme.breakpoints.down('xs')]: {
    PhoneNumberTxtField: {
      position: 'relative',
      top: '-10%',
    },

    root: {
      "& .MuiFormControlLabel-label": {
        fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
        fontWeight: 600,
        fontSize: '10px'
      },
    },
  }

}));

const ShippingAddress = () => {
  const classes = useStyles();
  const cart = useSelector(state => state.cartReducer, shallowEqual);

  // FORM INPUT VARIABLES FROM REDUX | HUGE PERFORMANCE OPTIMIZATION ON THE SLOW UI UPDATES
  const firstName = useSelector(state => state.cartReducer.shipping_address.first_name, shallowEqual);
  const lastName = useSelector(state => state.cartReducer.shipping_address.last_name, shallowEqual);
  const phone = useSelector(state => state.cartReducer.shipping_address.phone, shallowEqual);
  const company = useSelector(state => state.cartReducer.shipping_address.company, shallowEqual);
  const note = useSelector(state => state.cartReducer.shipping_address.note, shallowEqual);
  const address1 = useSelector(state => state.cartReducer.shipping_address.address1, shallowEqual);
  const address2 = useSelector(state => state.cartReducer.shipping_address.address2, shallowEqual);
  const city = useSelector(state => state.cartReducer.shipping_address.city, shallowEqual);
  const country = useSelector(state => state.cartReducer.shipping_address.country, shallowEqual);
  const province = useSelector(state => state.cartReducer.shipping_address.province, shallowEqual);
  const zip = useSelector(state => state.cartReducer.shipping_address.zip, shallowEqual);
  const saveInfo = useSelector(state => state.cartReducer.customer.save_information, shallowEqual);

  const customerEmail = useSelector(state => state.cartReducer.customer.email);
  const isRegistered = useSelector(state => state.cartReducer.customer.is_registered);
  const navAttempts = useSelector(state => state.navigationReducer.attempts);
  const geocoder = new window.google.maps.Geocoder();

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    updateCanContinue();
    dispatch(setExpandedType(""));
  }, [])

  useEffect(() => {
    updateCanContinue();
  }, [
    firstName,
    lastName,
    phone,
    note,
    company,
    address1,
    address2,
    country,
    city,
    province,
    zip,
    saveInfo,
    navAttempts
  ])

  return (
    <div className="ShippingAddressContainer" style={{ padding: '1rem' }}>
      {cart.shipping_address !== null ? renderCustomerName() : null}
      {/* { cart.shipping_address !== null ? renderPhoneCompany() : null} */}
      {cart.shipping_address !== null ? renderAddress() : null}
      {cart.shipping_address !== null ? renderInstructions() : null}
      {cart.shipping_address !== null ? renderCity() : null}
      {cart.shipping_address !== null ? renderRegionZip() : null}
      {cart.shipping_address !== null ? renderSaveCheckbox() : null}
    </div>
  )

  function renderCustomerName() {
    return (
      <div className="CustomerNameContainer">
        <CustomTextField
          fieldId={"first-name"}
          label="First Name"
          defaultValue={firstName}
          onEditCallBack={editFirstName}
          helperText="Field is required"
          onKeyPress={handleKeyPress}
          onBlur={handleBlur}
          navAttempts={navAttempts}
          key="fn"
        />
        <CustomTextField
          fieldId={"last-name"}
          label="Last Name"
          defaultValue={lastName}
          onEditCallBack={editLastName}
          helperText="Field is required"
          onKeyPress={handleKeyPress}
          onBlur={handleBlur}
          navAttempts={navAttempts}
          key="ln"
        />
      </div>
    )
  }

  function renderInstructions() {
    return (
      <div className="DeliveryInstructionsContainer">
        <AutoCompleteField
          fieldId={"address"}
          label={t("Address")}
          defaultValue={address1}
          onEditCallBack={editAddress}
          helperText={t("Field is required")}
          width={width60}
          onKeyPress={handleKeyPress}
          onBlur={handleBlur}
          navAttempts={navAttempts}
          key="ad"
        />
        <CustomTextField
          fieldId={"apartment"}
          label={t("Apt, suite, etc.")}
          defaultValue={address2}
          onEditCallBack={editApartment}
          optional={true}
          width={width10}
          containerStyle={width30}
          onKeyPress={handleKeyPress}
          onBlur={handleBlur}
          key="ap"
        />
      </div>
    )
  }

  function renderAddress() {
    return (
      <div className="AddressAptContainer">
        <CustomTextField
          fieldId={"company-name"}
          label="Company"
          defaultValue={company}
          onEditCallBack={editCompany}
          optional={true}
          containerStyle={width40}
          onKeyPress={handleKeyPress}
          onBlur={handleBlur}
          key="comp"
        />
        <CustomTextField
          fieldId={"phone"}
          label="Phone Number"
          defaultValue={phone}
          onEditCallBack={editPhone}
          helperText="Field is required"
          helperTextSecondary="Enter a valid phone number 438 795 2709"
          onKeyPress={handleKeyPress}
          onBlur={handleBlur}
          navAttempts={navAttempts}
          //className={classes.PhoneNumberTxtField}
          style={marginTop10}
          key="hs"
        />

      </div>
    )
  }

  function renderCity() {
    return (
      <div className="CityContainer">
        <CustomTextField
          fieldId={"city"}
          label="City"
          defaultValue={city}
          onEditCallBack={editCity}
          helperText="Field is required"
          // disabled={true}
          onKeyPress={handleKeyPress}
          onBlur={handleBlur}
          navAttempts={navAttempts}
          key="ct"
        />
        <CustomTextField
          fieldId={"province"}
          label="Province"
          defaultValue={province}
          onEditCallBack={editProvince}
          helperText="Field is required"
          // disabled={true}
          onKeyPress={handleKeyPress}
          onBlur={handleBlur}
          navAttempts={navAttempts}
          key="st"
        />

      </div>
    )
  }

  function renderRegionZip() {
    return (
      <div className="RegionZipContainer">
        <CustomTextField
          fieldId={"country"}
          label="Country"
          defaultValue={country}
          onEditCallBack={editCountry}
          helperText="Field is required"
          // disabled={true}
          containerStyle={width45}
          onKeyPress={handleKeyPress}
          onBlur={handleBlur}
          navAttempts={navAttempts}
          key="cc"
        />
        <CustomTextField
          fieldId={"zip"}
          country={cart.shipping_address.country}
          label="Postal Code"
          defaultValue={zip}
          onEditCallBack={editZip}
          helperText="Field is required"
          helperTextSecondary="Enter a valid postal code"
          onKeyPress={handleKeyPress}
          onBlur={handleBlur}
          navAttempts={navAttempts}
          key="zip"
        />

      </div>
    )
  }

  function renderSaveCheckbox() {
    return (
      <div className="SaveInfoContainer">
        <FormControlLabel
          control={
            <Checkbox
              checked={saveInfo}
              onChange={toggleSaveInfo}
              name="save-info"
              color="primary"
            />
          }
          className={classes.root}
          label={t("Save this information for next time")}
        />
      </div>
    )
  }

  function handleKeyPress(e) {

  }

  async function handleBlur(e) {
    let newAddress = getCompiledAddress();
    const addressUpdateResponse = await CartService.updateShippingAddress(newAddress, cart.token);

    if (addressUpdateResponse.address1) {
      dispatch(setShippingAddress(addressUpdateResponse))
    }
  }

  function updateLatLng(coordinates) {
    if (typeof coordinates.lat === 'string' && typeof coordinates.lng === 'string') {
      let payload = [
        { fieldToUpdate: 'latitude', value: coordinates.lat },
        { fieldToUpdate: 'longitude', value: coordinates.lng },
      ];
      dispatch(updateShippingAddress(payload));
    }
  }

  async function postUpdatedAddress() {
    let newAddress = getCompiledAddress();
    const addressUpdateResponse = await CartService.updateShippingAddress(newAddress, cart.token);
    return addressUpdateResponse;
  }

  function editFirstName(value) {
    let payload = [{ fieldToUpdate: 'first_name', value: value }];
    dispatch(updateShippingAddress(payload));
  }

  function editLastName(value) {
    let payload = [{ fieldToUpdate: 'last_name', value: value }];
    dispatch(updateShippingAddress(payload));
  }

  function editPhone(value) {
    let payload = [{ fieldToUpdate: 'phone', value: value }];
    dispatch(updateShippingAddress(payload));
  }

  function editCompany(value) {
    let payload = [{ fieldToUpdate: 'company', value: value }];
    dispatch(updateShippingAddress(payload));
  }

  function editInstructions(value) {
    let payload = [{ fieldToUpdate: 'note', value: value }];
    dispatch(updateShippingAddress(payload));
  }

  async function editAddress(value) {
    // let payload = getCompiledCustomerInfo();
    if (Array.isArray(value.terms)) {
      const lastIndex = value.terms.length - 1;

      let payload = [
        { fieldToUpdate: 'address1', value: value.terms[0].value + ' ' + value.terms[1].value },
        { fieldToUpdate: 'city', value: value.terms[lastIndex - 2].value },
        { fieldToUpdate: 'country', value: value.terms[lastIndex].value },
        { fieldToUpdate: 'province_code', value: value.terms[lastIndex - 1].value }

      ]

      geocoder.geocode({ 'placeId': value.place_id }, async (results, status) => {
        const addCompIndex = results[0].address_components.length - 1;
        for (var i = addCompIndex; i >= 0; i--) {
          let component = results[0].address_components[i];

          if (component.types.includes('postal_code')) {
            payload.push({ fieldToUpdate: 'zip', value: component.short_name })
            // break;
          } else if (component.types.includes('administrative_area_level_1')) {
            payload.push({ fieldToUpdate: 'province', value: component.long_name });
            payload.push({ fieldToUpdate: 'province_code', value: component.short_name })
          } else if (component.types.includes('country')) {
            payload.push({ fieldToUpdate: 'country_code', value: component.short_name })
          }
          if (payload.length === 8) {
            dispatch(updateShippingAddress(payload));
            break;
          }
        }
        const coordinates = { lat: results[0].geometry.location.lat().toString(), lng: results[0].geometry.location.lng().toString() }
        updateLatLng(coordinates);
        // setTimeout(async () => {
        //   const addressUpdateResponse = await postUpdatedAddress();
        //   updateLatLng(addressUpdateResponse);
        // },700)
      })
    }
  }

  function editApartment(value) {
    let payload = [{ fieldToUpdate: 'address2', value: value }];
    dispatch(updateShippingAddress(payload));
  }

  function editCity(value) {
    let payload = [{ fieldToUpdate: 'city', value: value }];
    dispatch(updateShippingAddress(payload));
  }

  function editCountry(value) {
    let payload = [{ fieldToUpdate: 'country', value: value }];
    dispatch(updateShippingAddress(payload));
  }

  function editProvince(value) {
    let payload = [{ fieldToUpdate: 'province', value: value }];
    dispatch(updateShippingAddress(payload));
  }

  function editZip(value) {
    let payload = [{ fieldToUpdate: 'zip', value: value }];
    dispatch(updateShippingAddress(payload));
  }

  function toggleSaveInfo(e) {
    let payload = [{ fieldToUpdate: 'save_information', value: e.target.checked }];
    dispatch(updateCustomer(payload));

    // let payload = getCompiledCustomerInfo();
    // payload.saveInfo = e.target.checked;
    // dispatch(setCustomerInfo(payload));
  }

  function getCompiledAddress() {
    return {
      shipping_address: {
        first_name: cart.shipping_address.first_name,
        last_name: cart.shipping_address.last_name,
        phone: cart.shipping_address.phone,
        company: cart.shipping_address.company,
        note: cart.shipping_address.note,
        address1: cart.shipping_address.address1,
        address2: cart.shipping_address.address2,
        city: cart.shipping_address.city,
        country: cart.shipping_address.country,
        country_code: cart.shipping_address.country_code,
        province: cart.shipping_address.province,
        province_code: cart.shipping_address.province_code,
        zip: cart.shipping_address.zip,
      }
    }
  }

  function updateCanContinue() {
    let canContinue = true;
    let fieldsToCheck = ['address1', 'first_name', 'last_name', 'country', 'phone', 'city', 'country_code', 'province', 'province_code', 'zip'];
    let fieldsLength = fieldsToCheck.length;

    for (let i = 0; i < fieldsLength; i++) {
      const field = fieldsToCheck[i];

      if (cart.shipping_address[field] === null || cart.shipping_address[field].length < 1) {
        canContinue = false;
      }
    }

    if (customerEmail === "" && isRegistered != true) {
      canContinue = false;
    }

    dispatch(setCanContinue(canContinue));
  }
}

export default ShippingAddress;
